import React, { useState, useEffect } from "react";
import PedirAjuda from "../components/forms/PedirAjuda";
import useAxios from "../helpers/useAxios";

const Ajuda = () => {
  const [message, setMessage] = useState('');

  const { fetch, data, error, loaded } = useAxios("", "", {}, true);

  useEffect(() => {
    if (loaded && error.length === 0)
    {
      if (data === true)
      {
        setMessage("Pedido de ajuda enviado com sucesso.");

        window.scrollTo(0, 0);
      }
    }
  }, [data]);

  const onSubmitPedido = dataForm => {
    fetch("POST", "/User/create-support", { 
      Name: dataForm.nome, 
      Email: dataForm.email,
      Subject: dataForm.assunto,
      Description: dataForm.comentario,
      Type: 1,
    });
  }

 return (
  <div className="container">
    <div className="row justify-content-md-center">
      <div className="col-md-8 bg-white my-5 rounded-4 p-5 pt-3">
        <h2 className="mt-4">Esclareça dúvidas</h2>
        <PedirAjuda onSubmitHandler={onSubmitPedido} message={message} />
      </div>
    </div>
  </div>
 );
};

export default Ajuda;
